import { useResourcePermissions } from "@/hooks/useResourcePermissions";
import { hasCascadeDeleteCapability } from "@/utils/permissions";

export interface CascadeDeletePermission {
  /** True only when the user holds the server-enforced grant (#5752). */
  hasCapability: boolean;
  /** True while permissions are still resolving — callers gate the
   *  "ask an administrator" copy on this so it doesn't flash during load. */
  isLoading: boolean;
}

/**
 * Resolves whether the current user holds the server-enforced
 * `documents:cascade-delete` capability (#5752).
 *
 * Routes the capability check through `useResourcePermissions` (ADR-044), the
 * project's single seam for resource-scoped permission reads, rather than
 * calling react-admin's `usePermissions` directly. The button that triggers a
 * destructive cascade gates on `hasCapability` in addition to the kill-switch
 * feature flag and the not-blocked impact preview — see DeleteImpactDialog.
 */
export const useCascadeDeletePermission = (): CascadeDeletePermission => {
  const { permissions, isLoading } = useResourcePermissions("documents");
  return { hasCapability: hasCascadeDeleteCapability(permissions), isLoading };
};
